<template>
  <div>
    <div class="container_item"
         v-for="(item) in video_newest"
         :key="item.vId"
         v-show="item.vFl==1"
         @click="toDetails(item)">
      <div class="item_con">
        <span class="egName">{{item.group.egName}}</span>


          <div style="position: relative;">
            <div v-if="checkUserMember">
              <get-vip-img v-if="item.vIsvipfree==1" ></get-vip-img>
            </div>

            <img class="con_images"
                :src="item.vPicUrl"
                alt
                v-if="item.vPicUrl" />
            <img class="con_images"
                :src="item.vViewUrl+'?x-oss-process=video/snapshot,t_5000,f_jpg,w_800,h_600,m_fast'"
                alt
                v-else />
          </div>


        <div class="text_desc">
          <p class="item_title">{{item.vTitle}}</p>
          <div class="item_text">
            <p>{{item.vSpeaker}}</p>
            <p>{{item.teacher?item.teacher.tOrg:''}}</p>
          </div>
        </div>
      </div>
      <div class="num_type">
        <p>
          <img src="../../assets/images/graysee.png"
               class="see"
               alt />
          <span>{{item.vViewCount}}人观看</span>
        </p>
        <p>
          <img src="../../assets/images/graylesson.png"
               class="lesson"
               alt />
          <span>
            <span v-if="item.vIsPublic==0">非</span>公开课

          </span>
        </p>
      </div>
    </div>
    <div v-if="video_newest.length<1"
         class="nothing">
      <img src="../../assets/images/nonelist.png"
           alt />

    </div>

  </div>
</template>
<script>
import weui from "weui.js";
import bus from "../../components/bus/index";
import GetVipImg from '../getvipimg/getVipImg.vue';
import loginService from "../../plugin/extendFn/loginService";
export default {
  components:{    GetVipImg},
  data () {
    return {
      checkUserMember:true,
      ismember: false,
      ra_wxUser: null
    };
  },
  props: {
    video_newest: {
      type: Array
    }
  },
  watch: {
    '$router': function (value) {
      console.log(value)
    },
  },
  methods: {
    getUser(){
      let type = this.ra_wxUser ? this.ra_wxUser.uMemberType : 0;
      if(type == 1 || type ==2){
        //this.checkUserMember = true;
      }
      console.log(this.ra_wxUser);
    },
    goPage () {
      this.$router.push({
        name: "Login",
        query: {}
      });
    },
    cancelMember () {
      this.ismember = false;
    },
    toDetails (item) {
      if (this.$route.name == "vDetails") {

        //公开课
        this.$router.push({
          name: "vDetails",
          query: { type: "video", videoId: item.vId }
        });
        // location.reload();

      } else {
        this.$router.push({
          name: "vDetails",
          query: { type: "video", videoId: item.vId }
        });
      }
    }
  },

  async mounted () {
    this.ra_wxUser=await loginService.getLoginUser();

        this.getUser();
  }
};
</script>
<style scoped lang="scss">
.nothing {
  background: #ffffff;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  img {
    width: 100%;
    display: inline-block;
  }
  div {
    font-size: 0.24rem;
    color: #47acff;
    text-align: center;
  }
  width: 100%;
}
.container_item {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: 1px solid #e6e6e6;
  background: #ffffff;
  width: 6.9rem;
  // height: 2.6rem;
  margin-bottom: 0.2rem;

  .item_con {
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    padding: 0.4rem 0.2rem 0.2rem;
    box-sizing: border-box;
    position: relative;
    .egName {
      position: absolute;
      top: 0.04rem;
      left: 0.2rem;
      font-size: 0.26rem;
      color: #666666;
    }
    .text_desc {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 1.6rem;
      margin-left: 0.2rem;
    }

    .item_title {
      width: 3.47rem;
      font-size: 0.28rem;
      font-weight: bold;
      display: -webkit-box;
      -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 2;
      line-height: 0.42rem;
      color: #333333;
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*文本超出显示省略号*/
    }
    .item_text {
      color: #666666;
      p {
        font-size: 0.24rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 3.47rem;
        /*line-height: 0.68rem;*/
        /*height: 0.25rem;*/
      }
    }
  }
  .num_type {
    font-size: 0.24rem;
    height: 0.6rem;
    display: flex;
    align-items: center;
    p {
      width: 3.44rem;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 0.28rem;
      color: #666666;
    }
    img {
      margin-right: 0.2rem;
    }
    .see {
      width: 0.4rem;
    }
    .lesson {
      width: 0.4rem;
    }
    p:nth-of-type(1) {
      border-right: 1px solid #e6e6e6;
    }
  }
}
.member {
  background: rgba(0, 0, 0, 0.5);
  min-width: 100vw;
  min-height: 100vh;
  position: fixed !important;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 9999 !important;
  > div {
    width: 5rem;
    z-index: 10001 !important;
    background: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    font-size: 0.16rem;
    margin: 4rem auto;
    height: 3.5rem;
    padding: 0.2rem 0.28rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ul {
      width: 100%;
      li:nth-of-type(1) {
        font-weight: bolder;
        font-size: 0.32rem;
      }
      li:nth-of-type(2) {
        text-indent: 0.56rem;
        font-size: 0.28rem;
        margin-top: 0.2rem;
      }
      li {
        width: 100%;
        font-size: 0.28rem;
      }
    }
    > p {
      width: 100%;
      display: flex;
      justify-content: space-between;
      button {
        width: 2rem;
        height: 0.6rem;
        border: none;
        outline: none;
        background: linear-gradient(#e7e8e9, #babbbb);
        color: #333;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
      }
      a > button {
        color: #ffffff;
        background: linear-gradient(#21afff, #007fff);
      }
    }
  }
}
.con_images {
  border: 1px solid #eeeeee;
  width: 2.84rem;
  height: 1.6rem;
  margin-right: 0.2rem;
}
.leve {
  width: 0.49rem;
  height: 0.49rem;
  position: absolute;
  z-index: 3;
}
</style>



// WEBPACK FOOTER //
// src/components/container/videoList.vue